import React, { useState } from 'react';

import { Tabs } from '@mui/material';

import Tooltip from 'components/Tooltip';
import { DashboardStep } from 'enums/DashboardStep';

import { Tab as StyledTab } from './Tab';
import styles from './TabsPanel.module.scss';

export interface Tab {
  id: DashboardStep;
  isExist: boolean;
  name: string;
  onClick: () => void;
  countRemaining?: number;
  isDisabled?: boolean;
  tooltipTitle?: string;
}

export interface TabsPanelProps {
  dashboardTabs: Tab[];
}

const TabsPanel = ({ dashboardTabs }: TabsPanelProps) => {
  const [currentTab, setCurrentTab] = useState<DashboardStep>(dashboardTabs.find((tab) => tab.isExist)!.id);

  const handleChange = (event: React.SyntheticEvent, newValue: DashboardStep) => {
    setCurrentTab(newValue);
  };

  return (
    <Tabs
      value={currentTab}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      TabIndicatorProps={{
        style: {
          backgroundColor: '#FF8000',
        },
      }}
    >
      {dashboardTabs.map(
        (tab) =>
          !!tab.isExist && (
            <StyledTab
              key={tab.id}
              value={tab.id}
              disabled={tab.isDisabled}
              onClick={tab.onClick}
              style={{ pointerEvents: 'auto' }}
              label={
                <Tooltip
                  title={tab.isDisabled && tab.tooltipTitle ? tab.tooltipTitle : ''}
                  placement="top"
                  onMouseOver={() => {}}
                  onClose={() => {}}
                >
                  <div>
                    <div>{tab.name}</div>
                    {!!tab.countRemaining ? (
                      <div className={styles.remaining}>{`*${tab.countRemaining} remaining`}</div>
                    ) : (
                      <div className={styles.completed}>completed</div>
                    )}
                  </div>
                </Tooltip>
              }
            />
          ),
      )}
    </Tabs>
  );
};

export default TabsPanel;
